export { default } from "./InfiniteCollectionSkeleton";
